export default "__VITE_ASSET__BXIHxKSq__"